<i class='fal fa-edit me-2 text-primary' (click)="edit()" *ngIf="params.edit"></i>
<i class='fal fa-trash-alt text-red' (click)="delete()" *ngIf="params.delete"></i>
